import { useQuery } from '@tanstack/react-query';

import { startMyPosSession } from '../api/payment.api';

export const useGetMyPosSession = (orderId: string, loyaltyId: number) => {
    return useQuery({
        queryKey: ['mypos-session', orderId, loyaltyId],
        queryFn: () => startMyPosSession(orderId, loyaltyId),
        staleTime: 0,
        enabled: Boolean(orderId),
    });
};
